import { render } from "./InboxPanel.vue?vue&type=template&id=db9abfe4&ts=true"
import script from "./InboxPanel.vue?vue&type=script&lang=ts"
export * from "./InboxPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__